//
//  Overview.tsx
//  TrajeXY Signet Server
//
//  Copyright © 2026 TrajeXY. All rights reserved.
//
//  Created: September 21, 2026
//  Author: Bob Keathley
//
//  Tenant overview page. Loads service health from /health.
//
import { useEffect, useState } from 'react'
import { api } from '@shared/api/client'
import { isOk, type Envelope } from '@shared/api/envelope'
import { atLeast, type Session } from '@shared/auth'

type Health = { status: string; service: string }
const when = (s: number | null | undefined) => (s ? new Date(s * 1000).toLocaleString() : '—')

export default function Overview({ session }: { session: Session }) {
  const [health, setHealth] = useState<Envelope<Health> | null>(null)
  useEffect(() => {
    api<Health>('/health').then(setHealth)
  }, [])
  const u = session.user
  return (
    <>
      <h2>Signed in</h2>
      <div className="grid">
        <div className="card"><div className="l">Account</div><div className="v mono">{u.email}</div></div>
        <div className="card"><div className="l">Role</div><div className="v">{u.role}</div></div>
        <div className="card"><div className="l">Tenant</div><div className="v mono">{u.tenant_id}</div></div>
        <div className="card"><div className="l">Session expires</div><div className="v">{when(session.expires_at)}</div></div>
        <div className="card"><div className="l">Last login</div><div className="v">{when(u.last_login_at)}</div></div>
        <div className="card">
          <div className="l">API</div>
          <div className="v">
            {health === null ? '…' : isOk(health) ? `${health.data.service} ${health.data.status}` : <span style={{ color: 'var(--deny)' }}>{health.error.code}</span>}
          </div>
        </div>
      </div>
      <h2>Go to</h2>
      <p><a href="#/fleet">Fleet</a> — machines, notebooks, deeds
        {atLeast(u.role, 'team-admin') && <> · <a href="#/machines">Machines</a> — enrol and revoke</>}
        {atLeast(u.role, 'security-admin') && <> · <a href="#/users">Users</a></>}
      </p>
      <p className="hint">Review queue, lineage, findings and policy views (06 §7) land as their routes go live.</p>
    </>
  )
}
